module.exports = __webpack_public_path__ + "img/combo_4.2cd97214.png";